import { Injectable, ErrorHandler } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {

  constructor(
    private notificationService: NotificationService
  ) {
    super();
  }
  handleError(error: any): void {
    this.notificationService.setNotificationType('error');
    super.handleError(error);
  }
}
